import React, { FC } from 'react';
import { MaterialIcon } from '../material-icon/MaterialIcon';
import styles from './system_button.module.scss';

export type SystemButtonProps = {
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  dataName?: string;
  disabled?: boolean;
  iconLeft?: string;
  iconRight?: string;
  type?: string;
  id?: string;
};

export const SystemButtonDefault = {
  onClick: () => {},
  dataName: '',
  disabled: false,
  iconLeft: '',
  iconRight: '',
  type: '',
  id: '',
};

export const SystemButtonContent: FC<{
  iconRight?: string;
  iconLeft?: string;
}> = ({ iconRight = '', children, iconLeft = '' }) => (
  <>
    {iconLeft && <MaterialIcon name={iconLeft} className={styles.iconLeft} />}
    {children}
    {iconRight && (
      <MaterialIcon name={iconRight} className={styles.iconRight} />
    )}
  </>
);
